import "../sass/main.scss";
// IMPORT JS
import { hideNavOnScroll } from "./modules/hideNavOnScroll.js";
import { activeButtonNav } from "./modules/activeButtonNav.js";
import { headerVisibility } from "./modules/headerManager.js";
import { handleCookieBanner } from "./modules/cookiesConsent.js";
import { detect404 } from "./modules/404Manager.js";
import { bgBodyManager } from "./modules/bodyBgManager.js";
import { toggleNotificationUI } from "./modules/notificationToogle.js";

document.addEventListener("DOMContentLoaded", async function () {
    const links = window.location.pathname.slice(1, -1);

    detect404();
    headerVisibility()
    hideNavOnScroll("nav-mobile");
    hideNavOnScroll("nav-mobile-bg");
    activeButtonNav("nav-mobile", "a", links);
    bgBodyManager(links)
    activeButtonNav("side-nav", "li", links);

    // Toggle notification UI and Activate cookie banner
    // if the page is not login
    if (links !== "login") {
        toggleNotificationUI();
        handleCookieBanner();
    }

    switch (true) {
        case /^(\/?|\/?home(\/.*)?)$/.test(links):
            import("./home/main.js").then((module) => module.default());
            break;

        case /^\/?(documents|document-category)(\/.*)?$/.test(links):
            import("./documents/main.js").then((module) => module.default());
            break;

        case /^\/?news(\/.*)?$/.test(links):
            import("./news/main.js").then((module) => module.default());
            break;

        case /^\/?notifications(\/.*)?$/.test(links):
            import("./notifications/main.js").then((module) => module.default());
            break;
    }
});
